// extracted by mini-css-extract-plugin
export default {"preferencesContainer":"DataAlertPreferences_preferencesContainer__tfo1T","categoryTable":"DataAlertPreferences_categoryTable__aLpTx"};